import { Box, CircularProgress, ListItemButton, Stack } from "@mui/material";
import { Text } from "@src/appV2/redesign/components/Text";
import { forwardRef } from "react";

interface LoadMoreItemProps {
  label: string;
  loading: boolean;
  selected: boolean;
  onClick: () => void;
}

export const LoadMoreItem = forwardRef<HTMLDivElement, LoadMoreItemProps>((props, ref) => {
  const { label, loading, selected, onClick } = props;

  return (
    <ListItemButton
      ref={ref}
      disabled={loading}
      selected={selected}
      sx={(theme) => ({
        paddingY: 2,
        paddingX: 4,
        justifyContent: "center",
        "&.Mui-selected": {
          backgroundColor: theme.palette.action.selected,
        },
      })}
      onClick={onClick}
    >
      <Stack direction="row" sx={{ alignItems: "center", gap: 2 }}>
        {loading && <CircularProgress size={14} />}
        <Box>
          <Text semibold color={loading ? "text.secondary" : "primary"} variant="body2">
            {loading ? "Loading…" : label}
          </Text>
        </Box>
      </Stack>
    </ListItemButton>
  );
});

LoadMoreItem.displayName = "LoadMoreItem";
